module.exports = __webpack_public_path__ + "static/media/Portrait-10031.f15dd0df.jpg";